import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    "& > * + *": {
      marginTop: "1.5rem",
    },
  },
  gap: {
    gap: theme.spacing(3),
  },
  header: {
    textTransform: "uppercase",
    "& h2": {
      marginBottom: "0",
    },
  },
  dropdownItems: {
    "& div.MuiFormControl-root": {
      margin: `${theme.spacing(2)}px 0 ${theme.spacing(2)}px 0`,
    },
  },
}));

export default useStyles;
